export const ERROR_LOAD_RETRY = 'Errore di caricamento — riprova';
